/*--------------------------------------------------------------
# Pathway Card Feed
# - toggles between the Category and Interest panels
# - carousel layout: container-bound scroll carousel with paged
#   pagination (one tab per page of cards that fit in view)
--------------------------------------------------------------*/

(function () {
	function initCarousel(carousel) {
		var viewport = carousel.querySelector('.pathway-card-feed__viewport');
		var track = carousel.querySelector('.pathway-card-feed__track');
		// Excludes the trailing __gutter spacer - it's not a card, and counting
		// it would throw off slideStep()'s "distance between two cards" math
		// whenever there's only one real card.
		var slides = track ? Array.prototype.slice.call(track.children).filter(function (el) {
			return !el.classList.contains('pathway-card-feed__gutter');
		}) : [];

		if (!viewport || !slides.length) {
			return null;
		}

		// Some browsers (Chrome) restore a scrollable element's scroll
		// position across a reload, so without this the carousel can start
		// mid-way through on a refresh instead of at the first card.
		viewport.scrollLeft = 0;

		var prev = carousel.querySelector('.pathway-card-feed__arrow--prev');
		var next = carousel.querySelector('.pathway-card-feed__arrow--next');
		var tabs = Array.prototype.slice.call(carousel.querySelectorAll('.pathway-card-feed__tab'));

		// Distance from one card's start to the next.
		function slideStep() {
			if (slides.length < 2) {
				return slides[0].offsetWidth;
			}
			return slides[1].offsetLeft - slides[0].offsetLeft;
		}

		// How many whole cards fit in view - one page, and what one arrow press
		// moves. Mobile cards fill the viewport, so this is 1 there.
		function viewCount() {
			var step = slideStep();
			return step > 0 ? Math.max(1, Math.floor(viewport.clientWidth / step)) : 1;
		}

		function pageWidth() {
			return slideStep() * viewCount();
		}

		// The markup carries one tab per card - the most that can be needed. Any
		// beyond the current page count get hidden rather than removed, so they
		// come back if the viewport widens or narrows again.
		function pageCount() {
			return Math.max(1, Math.min(tabs.length, Math.ceil(slides.length / viewCount())));
		}

		function maxScroll() {
			return viewport.scrollWidth - viewport.clientWidth;
		}

		function updateControls() {
			var left = viewport.scrollLeft;
			var max = maxScroll();

			if (prev) {
				prev.disabled = left <= 1;
			}
			if (next) {
				next.disabled = left >= max - 1;
			}

			if (tabs.length) {
				var pages = pageCount();
				var page = pageWidth() > 0 ? Math.round(left / pageWidth()) : 0;
				// Snap the last tab active once we reach the end.
				if (left >= max - 1) {
					page = pages - 1;
				}
				page = Math.max(0, Math.min(pages - 1, page));
				tabs.forEach(function (tab, index) {
					var active = index === page;
					tab.hidden = index >= pages;
					tab.classList.toggle('is-active', active);
					tab.setAttribute('aria-selected', active ? 'true' : 'false');
				});
			}
		}

		function scrollByCards(count) {
			viewport.scrollTo({
				left: viewport.scrollLeft + count * slideStep(),
				behavior: 'smooth'
			});
		}

		if (prev) {
			prev.addEventListener('click', function () {
				scrollByCards(-viewCount());
			});
		}
		if (next) {
			next.addEventListener('click', function () {
				scrollByCards(viewCount());
			});
		}

		tabs.forEach(function (tab, index) {
			tab.addEventListener('click', function () {
				viewport.scrollTo({
					left: Math.min(maxScroll(), index * pageWidth()),
					behavior: 'smooth'
				});
			});
		});

		var scrollTimer;
		viewport.addEventListener('scroll', function () {
			window.clearTimeout(scrollTimer);
			scrollTimer = window.setTimeout(updateControls, 60);
		});

		window.addEventListener('resize', function () {
			updateControls();
		});

		updateControls();

		return updateControls;
	}

	function initPathwayCardFeed(root) {
		var switchButton = root.querySelector('[data-pathway-switch]');
		var labels = Array.prototype.slice.call(root.querySelectorAll('[data-pathway-view]'));

		// A hidden panel has no measurable width, so its controls have to be
		// refreshed once the view it belongs to is shown.
		var refreshers = Array.prototype.slice
			.call(root.querySelectorAll('[data-pathway-carousel]'))
			.map(initCarousel)
			.filter(Boolean);

		function setView(view) {
			root.setAttribute('data-active-view', view);
			if (switchButton) {
				switchButton.setAttribute('aria-checked', view === 'interest' ? 'true' : 'false');
			}
			refreshers.forEach(function (refresh) {
				refresh();
			});
		}

		if (switchButton) {
			switchButton.addEventListener('click', function () {
				var current = root.getAttribute('data-active-view');
				setView(current === 'interest' ? 'category' : 'interest');
			});
		}

		labels.forEach(function (label) {
			label.addEventListener('click', function () {
				setView(label.getAttribute('data-pathway-view'));
			});
		});
	}

	function init() {
		Array.prototype.slice
			.call(document.querySelectorAll('[data-pathway-card-feed]'))
			.forEach(initPathwayCardFeed);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
